/**
 * The locale switcher, in the footer of every page.
 *
 * One control for language and region together, because they are one value
 * (shared/locales.ts). Choosing keeps the page: `setLocale` moves to the same
 * path under the new prefix and records the choice in the cookie the front
 * door reads.
 */

import { LOCALES } from '@shared/locales';
import { ds } from '../ds';
import { useRouter } from '../router';
import { useT } from '../i18n';

const OPTIONS = LOCALES.map((l) => ({ value: l.tag, label: l.native }));

export function LocaleSwitch() {
  const { Select } = ds();
  const { locale, setLocale } = useRouter();
  const t = useT();

  return (
    <span className="mv-locale-switch" title={t('common.locale.label')}>
      <Select
        options={OPTIONS}
        value={locale}
        onChange={(e) => setLocale(e.target.value)}
        style={{ width: 200 }}
      />
    </span>
  );
}
